import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Header } from "../../../components/header/Header"
import { DownloadDocumentsWrapper, DownloadLink, IconWrapper } from "./styles"
import { faArrowAltCircleRight } from "@fortawesome/free-solid-svg-icons"

export const DownloadDocuments = () => {
    return (
        <DownloadDocumentsWrapper>
            <Header>Download Documents</Header>
            <DownloadLink>
                <IconWrapper>
                    <FontAwesomeIcon icon={faArrowAltCircleRight} color='#3b82f6' />
                </IconWrapper> 
                <a href='./pdf/celeste-mall-brochure.pdf' target='_black'>Celeste Brochure</a>
            </DownloadLink>
        </DownloadDocumentsWrapper>
    )
}